module.exports = __webpack_public_path__ + "static/media/page header scenery 3.707cb7f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/page header scenery 3.svg
// module id = 56
// module chunks = 0